import { CUSTOMER_ANALYTICS_POLICY_VERSION } from '../shared/customer-analytics.js';

export function signupAnalyticsFields(enabled: boolean) {
  return { customer_analytics_choice: enabled, customer_analytics_policy: CUSTOMER_ANALYTICS_POLICY_VERSION };
}

export function signupAnalyticsUrl(url: string, enabled: boolean): string {
  const parsed = new URL(url, window.location.origin);
  parsed.searchParams.set('customer_analytics_choice', String(enabled));
  parsed.searchParams.set('customer_analytics_policy', CUSTOMER_ANALYTICS_POLICY_VERSION);
  return `${parsed.pathname}${parsed.search}`;
}
